import { useState, useCallback, useMemo } from "react";
import transactionRequestService from "../services/transactionRequestService";
import { useGeneralMessage } from "../../common/APICommon";

export const useTransactionRequest = (user) => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Destructure showGeneralMessage but keep other props for the returned UI
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  // // MODIFIED: Stable dependency on showGeneralMessage
  const fetchData = useCallback(async (requestTypeId = 0) => {
    // Only proceed if we have a valid employee ID
    const approverId = user?.employeePersonalInformationId;
    if (!approverId) return;

    setLoading(true);
    try {
      const data = await transactionRequestService.getEmployeeUnderMe(
        approverId,
        15,
        requestTypeId
      );
      setRequests(data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
      showGeneralMessage("Error loading requests.", false);
    } finally {
      setLoading(false);
    }
  }, [user?.employeePersonalInformationId, showGeneralMessage]); // Precise dependencies

  const handleAction = async (item, status, remarks) => {
    setLoading(true);
    try {
      const payload = {
        approvalId: item.approvalId,
        detailId: item.currentStepId,
        status: status,
        remarks: remarks,
        approverId: user.employeePersonalInformationId,
        requestTypeId: item.requestTypeId,
        requestId: item.id
      };

      await transactionRequestService.actionRequest(payload);
      showGeneralMessage(`Request successfully ${status}.`, true);
      return { success: true };
    } catch (err) {
      const msg = err.response?.data?.message || "Action failed.";
      showGeneralMessage(msg, false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!requests) return [];
    const lowerSearch = searchTerm.toLowerCase();
    return requests.filter(r =>
      r.fullName?.toLowerCase().includes(lowerSearch) ||
      r.formattedReferenceNumber?.toLowerCase().includes(lowerSearch)
    );
  }, [requests, searchTerm]);

  return {
    loading,
    data: filteredData,
    searchTerm,
    setSearchTerm,
    fetchData,
    handleAction,
    showMessage,
    message,
    isSuccess
  };
};